module.exports = __webpack_public_path__ + "img/ch-stationary1-res.8f61b0f8.jpg";